"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callsTranslations = {
    "en": {
        callsPerHourSince: "Calls per hour (Since ",
        callsPerHour: "Calls per hour",
        infoText: "Metrics for this agent's inbound calls over time, represented by total calls, rolled\n        calls and calls per hour.",
        calls: "Calls",
        totalCalls: "Total Calls",
        rolledCalls: "Rolled Calls",
    },
    "de": {
        infoText: "Messwerte f\u00FCr die eingehenden Anrufe dieses Mitarbeiters \u00FCber einen l\u00E4ngeren Zeitraum, dargestellt durch die Gesamtzahl der Anrufe, umgeleitete\n        Anrufe und Anrufe pro Stunde.",
        callsPerHourSince: "Anrufe pro Stunde (seit",
        totalCalls: "Gesamtzahl der Anrufe",
        calls: "Anrufe",
        rolledCalls: "Umgeleitete Anrufe",
        callsPerHour: "Anrufe pro Stunde",
    },
    "nl": {
        infoText: "Metrieken voor de inkomende oproepen van deze agent over de tijd, vertegenwoordigd door totale oproepen, naam-\n        afroepingen, en oproepen per uur.",
        callsPerHourSince: "Oproepen per uur (sinds",
        totalCalls: "Totale oproepen",
        calls: "Oproepen",
        rolledCalls: "Doorgegeven oproepen",
        callsPerHour: "Oproepen per uur",
    },
    "it": {
        infoText: "Le metriche delle chiamate di questo agente nel tempo, rappresentata con chiamate totali, inoltrate\n        e chiamate per ora.",
        callsPerHourSince: "Chiamate per ora (dal",
        totalCalls: "Chiamate in totale",
        calls: "Chiamate",
        rolledCalls: "Chiamate inoltrate",
        callsPerHour: "Chiamate per ora",
    },
    "fr": {
        infoText: "Indicateurs pour les appels entrants de cet agent au cours du temps, repr\u00E9sent\u00E9s par le nombre total d'appels, les appels connect\u00E9s\n        et le nombre d'appels par heure.",
        callsPerHourSince: "Nombre d'appels par heure (depuis",
        totalCalls: "Nombre total d'appels",
        calls: "Appels",
        rolledCalls: "Appels connectés",
        callsPerHour: "Nombre d'appels par heure",
    },
    "es": {
        infoText: "Los par\u00E1metros para las llamadas entrantes de este agente en funci\u00F3n del transcurso del tiempo, representados por el total de llamadas,\n        las llamadas trasladadas y las llamadas por hora.",
        callsPerHourSince: "Llamadas por hora (Desde",
        totalCalls: "Total de llamadas",
        calls: "Llamadas",
        rolledCalls: "Llamadas trasladadas",
        callsPerHour: "Llamadas por hora",
    },
    "ja": {
        infoText: "\u5408\u8A08\u901A\u8A71\u6570\u3001\u7121\u5FDC\u7B54\u8EE2\u9001\u901A\u8A71\u6570\u3001\u6642\u9593\u3042\u305F\u308A\u901A\u8A71\u6570\u306B\u3088\u308A\u8868\u3055\u308C\u308B\n        \u3053\u306E\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306E\u53D7\u4FE1\u901A\u8A71\u306E\u7D4C\u6642\u7684\u306A\u6307\u6A19",
        callsPerHourSince: "時間あたり通話数（開始日時：",
        totalCalls: "合計通話数",
        calls: "通話",
        rolledCalls: "無応答転送通話",
        callsPerHour: "時間あたり通話数",
    },
    "en-GB": {
        infoText: "Metrics for this agent's inbound calls over time, represented by total calls, rolled\n        calls and calls per hour.",
        callsPerHourSince: "Calls per hour (Since",
        totalCalls: "Total Calls",
        calls: "Calls",
        rolledCalls: "Rolled Calls",
        callsPerHour: "Calls per hour",
    },
    "ru": {
        callsPerHourSince: "Количество звонков в час (С ",
        callsPerHour: "Количество звонков в час",
        infoText: "\u041C\u0435\u0442\u0440\u0438\u043A\u0430 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0430\u0433\u0435\u043D\u0442\u0430 \u0437\u0430 \u0437\u0430\u0434\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \n        \u043E\u0431\u0449\u0438\u043C \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u043C \u0437\u0432\u043E\u043D\u043A\u043E\u0432, \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0445 \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0438 \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0432 \u0447\u0430\u0441.",
        calls: "Звонки",
        totalCalls: "Всего Звонков",
        rolledCalls: "Перенаправленные Звонки",
    },
};
